import type { EbookQuestion } from '@wx-weiqi/contracts';
import type { EbookClient } from './ebooks';
import { nextRequestId } from './http';

/** Reuse the same idempotency key after an uncertain network outcome. */
export class EbookQuestionWriter {
  private retry: { payload: string; requestId: string } | null = null;
  async save(
    client: Pick<EbookClient, 'saveQuestion'>,
    id: string,
    version: number,
    question: EbookQuestion,
    newChapter?: string,
  ) {
    const payload = JSON.stringify([id, version, question, newChapter]);
    if (this.retry?.payload !== payload)
      this.retry = { payload, requestId: nextRequestId('ebook-question') };
    const requestId = this.retry.requestId;
    const result = await client.saveQuestion(id, version, question, requestId, newChapter);
    if (this.retry?.requestId === requestId) this.retry = null;
    return result;
  }
}
